
//////////////////////// Industry we surve //////////////////////////////

export const industries = [
  {
    name: 'Real State',
    image: 'imgs/icons/house.svg'
  },
  {
    name: 'Tour & Travels',
    image: 'imgs/icons/travel-case.svg'
  },
  {
    name: 'Education',
    image: 'imgs/icons/video-tutorials.svg'
  },
  {
    name: 'Transport',
    image: 'imgs/icons/taxi.svg'
  },
  {
    name: 'Event',
    image: 'imgs/icons/event.svg'
  },
  {
    name: 'eCommerce',
    image: 'imgs/icons/smartphone.svg'
  },
  {
    name: 'Game',
    image: 'imgs/icons/joystick.svg'
  },
  {
    name: 'Healthcare',
    image: 'imgs/icons/healthcare.svg'
  },
  {
    name: 'Finance',
    image: 'imgs/icons/money-growth.svg'
  },
  {
    name: 'Restaurant',
    image: 'imgs/icons/baker.svg'
  },
  {
    name: 'On-Demand',
    image: 'imgs/icons/mobile-app.svg'
  },
  {
    name: 'Grocery',
    image: 'imgs/icons/groceries.svg'
  },
]
///////////////////////////////// our services //////////////////////////////

export const ourServices = [
  {
    name: 'Web Designing',
    content: "Take your business online with responsive websites.",
    image: "imgs/icons/branding.svg"
  },
  {
    name: 'App Development',
    content: "Surf your business on smart phone applications.",
    image: "imgs/icons/development.svg"
  },
  {
    name: 'Graphic Designing',
    content: "Crafting your brand perspective with creativity.",
    image: "imgs/icons/app.svg"
  },
  {
    name: 'Digital Marketing',
    content: "Make your mark online in top search results.",
    image: "imgs/icons/marketing.svg"
  },
]

////////////////////////////// Why choose Us ///////////////////////////////////

export const whyChooseUs = [
  {
    name: 'Creating Quintessential',
    content: 'Creating your perfect for your business',
    image: 'imgs/icons/research.svg'
  },
  {
    name: 'Ingenious Solutions',
    content: 'Uniqueness of your business shown to everyone else in the world',
    image: 'imgs/icons/chat.svg'
  },
  {
    name: 'Transparency with Clients',
    content: 'Everything that we do gets approved first.',
    image: 'imgs/icons/monitor.svg'
  },
  {
    name: 'Research & Analysis',
    content: 'Complete research of what you and your business want from us',
    image: 'imgs/icons/trasparency.svg'
  },

]

/////////////////////////////////// Statistics /////////////////////////////////////

export const statistics =[
  {
    count:'6+',
    content:'Year in Business',
    image:"imgs/icons/startup.svg"
  },
  {
    count:'25+',
    content:'Team Members',
    image:"imgs/icons/team.svg"
  },
  {
    count:'100+',
    content:'Happy Clients',
    image:"imgs/icons/deal.svg"
  },
  {
    count:'150+',
    content:'Projects Done',
    image:"imgs/icons/computers.svg"
  },
  {
    count:'200k+',
    content:'Hours Worked',
    image:"imgs/icons/worker.svg"
  },
  {
    count:'24/7',
    content:'Support Available',
    image:"imgs/icons/customer-service.svg"
  }

]

/////////////////////////////////// Portfolio //////////////////////////////////

export const portfolio=[
  {
    title:'GISR Foundation',
    image:"imgs/work/web4.png"
  },
  {
    title:'IIWA Awards 2021',
    image:'imgs/work/web5.png'
  },
  {
    title:'Tartch LLP',
    image:'imgs/work/web8.png'
  },
  {
    title:'Daily Needs & Sweets',
    image:'imgs/work/app1.png'
  },
  {
    title:'My Easy Doctor',
    image:'imgs/work/app2.png'
  },
  {
    title:'The Career Factory',
    image:'imgs/work/app3.png'
  },
]

//////////////////////////////// Testinomial /////////////////////////////////

export const testinomial=[
  {
    userReview:"I met them for one of my project. I must tell you people here are so enthusiastic that they provide you end to end solutions in every case.  I am really pleased by their team efforts and definitely refer S K Info Techies. All the best ✌️",
    userName:'Pankaj Mishra',
    userInfo:'Founder, P N D Global Logistics'
  },
  {
    userReview:"We were unknown to each other when I became their client now after a couple of months. We are a family that's how friendly & convenient this company is.",
    userName:'Ayush Sharma',
    userInfo:'Founder, Weddingrows'
  },
  {
    userReview:"Brilliant Team with some super creative minds who all are there for all your e-world needs.",
    userName:'Sumit Kapoor',
    userInfo:'Life Coach, Winspiration'
  },
  {
    userReview:"Team of Professionals who can develop any kind of IT related queries within Time Frame. Good Quality Work. Best Services. And I'm proud that my batch mates are the Founders of VGeekers and achieving heights Day by Day!!",
    userName:'Prashul Kumar',
    userInfo:'Graduate Engineer Trainee, PPAP Automative Pvt. Ltd.'
  },
  {
    userReview:"The availability of executives in KaviRo is upto the mark and the response rate is very high. They are also available to provide solutions in non-working hours. I am grateful to be associated with them.",
    userName:'Kuldeep Singh',
    userInfo:'Corporate Officer, HDFC Bank'
  },
  {
    userReview:"KaviRo is best in providing quality solutions in web development and graphic designing. I am glad to be associated with KaviRo.",
    userName:'Minakshi',
    userInfo:'Director, GISR Foundation'
  }
]


///////////////////////////////// Clients ////////////////////////////////////////

export const clients=[
  {
    image:"imgs/client/logos/igdtuw_logo.jpg"
  },
  {
    image:"imgs/client/logos/client-1.png"
  },
  {
    image:"imgs/client/logos/client-2.png"
  },
  {
    image:"imgs/client/logos/client-3.png"
  },
  {
    image:"imgs/client/logos/client-4.png"
  },
  {
    image:"imgs/client/logos/client-5.png"
  },
  {
    image:"imgs/client/logos/client-6.png"
  },
  {
    image:"imgs/client/logos/client-7.png"
  },
  {
    image:"imgs/client/logos/client-8.png"
  },
  {
    image:"imgs/client/logos/client-9.png"
  },
  {
    image:"imgs/client/logos/client-10.png"
  },
  {
    image:"imgs/client/logos/client-11.png"
  },
  
]

//////////////////////////// Location We Serve //////////////////////////////

export const location = [
  {
    title:'India',
    image:'imgs/flags/india.png'
  },
  {
    title:'UAE',
    image:'imgs/flags/uae.png'
  },
  {
    title:'Australia',
    image:'imgs/flags/australia.png'
  },
  {
    title:'Canada',
    image:'imgs/flags/canada.png'
  },
  {
    title:'USA',
    image:'imgs/flags/usa.png'
  },
  {
    title:'South Africa',
    image:'imgs/flags/south-africa.png'
  },
  {
    title:'Estonia',
    image:'imgs/flags/estonia.png'
  },
  {
    title:'Dominica',
    image:'imgs/flags/dominica.png'
  },
  {
    title:'Oman',
    image:'imgs/flags/oman.png'
  },
  {
    title:'Germany',
    image:'imgs/flags/germany.png'
  },
  {
    title:'Austria',
    image:'imgs/flags/austria.png'
  },
  {
    title:'Switzerland',
    image:'imgs/flags/switzerland.png'
  },
  {
    title:'Saudi',
    image:'imgs/flags/saudi.png'
  },
  {
    title:'Singapore',
    image:'imgs/flags/singapore.png'
  },
]
